import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import EstimatedTime from './EstimatedTime';
import UserConsumption from './UserConsumption';
import './Telemetry.css';

const TAB_SX = {
  '& .MuiTab-root': {
    color: '#6b7280',
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.95rem',
    minHeight: '48px',
  },
  '& .MuiTab-root.Mui-selected': { color: '#f97316' },
  '& .MuiTabs-indicator': { backgroundColor: '#f97316', height: '2px' },
};

const Telemetry = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="telemetry-page">
      <div className="page-header">
        <h2 className="page-title">Telemetry</h2>
      </div>

      <Box sx={{ borderBottom: 1, borderColor: '#1a1a2e', mb: 2 }}>
        <Tabs value={activeTab} onChange={(_, v) => setActiveTab(v)} sx={TAB_SX}>
          <Tab label="Estimated Time" />
          <Tab label="User Consumption" />
        </Tabs>
      </Box>

      {activeTab === 0 && <EstimatedTime />}
      {activeTab === 1 && <UserConsumption />}
    </div>
  );
};

export default Telemetry;
